import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { TrevorComponent } from '@trevor/ui-components';
import {
  getDashboardChartWidgets,
  getDashboardFilters,
} from '@/store-selectors';
import LayerWhere from '@/components/layers/LayerWhere';
import { useAppSelector } from '@/store/hooks';
import {
  selectChartWidgetIndex,
  selectFilters,
} from '@/features/dashboard/dashboardSlice';
import { WidgetFilter } from './WidgetFilter';
import {
  getIsApplied,
  getWidgetBeingEditedFilters,
  getWidgetFilters,
} from './utils';

const _WidgetFilters: TrevorComponent<{ widgetIndex: number }> = ({
  widgetIndex,
  className,
}) => {
  const widgetBeingEditedIndex = useAppSelector(selectChartWidgetIndex);
  const widgetBeingEditedFilters = useAppSelector(selectFilters);
  const dashboardFilters = useSelector(getDashboardFilters);
  const appliedFilters: LayerWhere[] = useSelector(
    (s: any) => s.dashboards.appliedFilters,
  );
  const seriesId = useSelector(getDashboardChartWidgets)?.[widgetIndex]?.series;

  if (!seriesId) return null;

  const widgetFilters =
    widgetBeingEditedIndex === widgetIndex
      ? getWidgetBeingEditedFilters(
          widgetBeingEditedFilters.dashboardFiltersIds,
          dashboardFilters,
        )
      : getWidgetFilters(seriesId, dashboardFilters);

  return (
    <div className={className}>
      {widgetFilters.map((widgetFilter) => (
        <div key={widgetFilter._id}>
          <WidgetFilter
            widgetFilter={widgetFilter}
            isApplied={getIsApplied(appliedFilters, widgetFilter)}
            appliedFilters={appliedFilters}
          />
        </div>
      ))}
    </div>
  );
};

export const WidgetFilters = styled(_WidgetFilters)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
